import '~/public/styles/global.scss';
import { useEffect, useState } from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import Head from 'next/head';
import { useRouter } from 'next/router';
import CssBaseline from '@material-ui/core/CssBaseline';
import { useDispatch, useStore } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import AOS from 'aos';
import NextNprogress from 'nextjs-progressbar';

import { ToastContainer, Slide } from 'react-toastify';

import AppLoading from '@/components/global/AppLoading';
import theme from '@/theme';
import { wrapper } from '@/actions/store';

import { logScreenView } from '@/utils/firebase';
import { devMode } from '@/utils';

import { SetDispatch } from '@/actions';

const MyApp = ({ Component, pageProps }) => {
  const routers = useRouter();
  const store = useStore((state) => state);
  const [loading, setLoading] = useState(true);

  // set global store dispatcher
  const dispatch = useDispatch();
  useEffect(() => {
    SetDispatch(dispatch);
  }, [dispatch]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    window.onload = () => setLoading(false);

    // Remove the server-side injected CSS.
    const jssStyles = document.querySelector('#jss-server-side');
    if (jssStyles) jssStyles.parentElement.removeChild(jssStyles);
    AOS.init({
      delay: 300,
      duration: 1000,
      once: true,
    });

    // firebase analytics
    if (!devMode) {
      routers.events.on('routeChangeComplete', logScreenView);
      logScreenView(window.location.pathname);

      return () => {
        routers.events.off('routeChangeComplete', logScreenView);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Head>
        <title>decooj</title>
        <meta
          name="viewport"
          content="minimum-scale=1, initial-scale=1, width=device-width"
        />
      </Head>

      {loading ? <AppLoading /> : null}

      <ThemeProvider theme={theme}>
        <ToastContainer
          theme="colored"
          transition={Slide}
          hideProgressBar
          closeOnClick
          rtl
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        <NextNprogress
          color="#218683"
          startPosition={0.3}
          stopDelayMs={200}
          height={4}
          showOnShallow
          options={{ showSpinner: false }}
        />
        <PersistGate persistor={store.__persistor} loading={null}>
          <Component {...pageProps} />
        </PersistGate>
      </ThemeProvider>
    </>
  );
};

export default wrapper.withRedux(MyApp);
